<template>
  <div class="detail-page">
    <div class="detail-page__left"
         v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
      <div class="admin-edit" @click="editTranslate(['payPalButtons_paypalButton',])"></div>
      <CardLeftBlock
              :name="''"
              :value="''"
              :backgroundImage="'listing'"
      >
        <template slot="button">
          <h2 class="mt-0">{{$t('payPalButtons_paypalButton.localization_value.value')}}</h2>
          <div class="card-detail-left__date">
            {{ new Date() | moment("DD MMM, YYYY") }}
          </div>
        </template>
      </CardLeftBlock>
    </div>

    <div class="detail-page__right">
      <CardRightBlock>
        <template slot="header">
          <div class="order-create__head">
            <div class="order-create__head-line">
              <div class="order-create__header-col"
                   v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                <div class="admin-edit" @click="editTranslate(['payPalButtons_BackToList',])"></div>
                <router-link :to="$store.getters.GET_PATHS.financeUkrTreasuresLink + '?page=1&count=25&type=paypalListings'" class="order-create__head-back">
                  <LinkBack
                          :value="$t('payPalButtons_BackToList.localization_value.value')"
                  />
                </router-link>
              </div>
            </div>
            <div class="order-create__head-title"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['payPalButtons_createPayPalButton',])"></div>
              {{$t('payPalButtons_createPayPalButton.localization_value.value')}}
            </div>
          </div>
        </template>

        <template slot="body">
          <div class="order-create__section">
            <div class="fragment">

              <div class="custom-row">
                <div class="custom-col custom-col--33 custom-col--md-100"
                     v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                  <div class="admin-edit" @click="editTranslate([
                    'payPalButtons_name',
                    ])"></div>
                  <DefaultInput
                      :label="$t('payPalButtons_name.localization_value.value')"
                      v-bind:class="{'ui-no-valid': PayPalButton.validation.name}"
                      :errorTxt="$t(`${PayPalButton.validationTranslate.name}.localization_value.value`)"
                      :error="PayPalButton.validation.name"
                      v-model="PayPalButton.data.name"
                  />
                </div>
              </div>

              <div class="custom-row">
                <div class="custom-col custom-col--33 custom-col--md-100"
                     v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
                  <div class="admin-edit" @click="editTranslate([
                    'payPalButtons_price',
                    ])"></div>
                  <DefaultInput
                      :label="$t('payPalButtons_price.localization_value.value')"
                      v-bind:class="{'ui-no-valid': PayPalButton.validation.price}"
                      :errorTxt="$t(`${PayPalButton.validationTranslate.price}.localization_value.value`)"
                      :error="PayPalButton.validation.price"
                      v-model="PayPalButton.data.price"
                  />
                </div>
              </div>

            </div>
          </div>
        </template>

        <template slot="footer">
          <div class="order-create__footer">

            <div class="order-create__footer-link"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_cancel',])"></div>
              <router-link :to="$store.getters.GET_PATHS.financeUkrTreasuresLink + '?page=1&count=25&type=paypalListings'"
                           class="site-link site-link--alt"
              >
                {{$t('common_cancel.localization_value.value')}}
              </router-link>
            </div>

            <div class="order-create__footer-btn ml-auto"
                 v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
              <div class="admin-edit" @click="editTranslate(['common_create'])"></div>

              <MainButton
                      class="order-create__footer-btn-i"
                      :value="$t('common_create.localization_value.value')"
                      @click.native="$emit('save')"
              />
            </div>

          </div>
        </template>
      </CardRightBlock>

    </div>
  </div>
</template>

<script>
  import CardLeftBlock from "../../../../../../components/coreComponents/CardLeftBlock/CardLeftBlock.vue";
  import MainButton from "../../../../../../components/UI/buttons/MainButton/MainButton";
  import CardRightBlock from "../../../../../coreComponents/CardRightBlock/CardRightBlock.vue";
  import LinkBack from "../../../../../UI/buttons/LinkBack/LinkBack.vue";
  import DefaultInput from "../../../../../UI/inputs/DefaultInput/DefaultInput";

  export default {
    name: "UkrTreasuresPayPalButtonsCreateSection",

    components: {
      DefaultInput,
      CardLeftBlock,
      MainButton,
      CardRightBlock,
      LinkBack,
    },

    props: {
      PayPalButton: Object,
    },

    data() {
      return {

      }
    },

    methods: {
    }
  }
</script>

<style lang="scss">

</style>
